/** Shared default when no workspace / brand-kit language is set */
export const DEFAULT_LANGUAGE = 'English'
